import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { HrefDirective } from '../../../directives/href/href.directive';
import { IconComponent } from '../../../components/icon/icon.component';

import { TickerSymbolStatus } from '../ticker-symbol.domain';

@Component({
  selector: 'td-wb-ticker-symbol-warnings',
  templateUrl: 'ticker-symbol-warnings.component.html',
  styleUrls: ['ticker-symbol-warnings.component.scss'],
  imports: [
    IconComponent,
    TranslateDirective,
    HrefDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TickerSymbolWarningsComponent {
  @Input() symbolStatus: TickerSymbolStatus;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly SymbolStatus: typeof TickerSymbolStatus = TickerSymbolStatus;
}
